class ProductForm extends HTMLElement {
  constructor() {
    super();   
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('#cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const embroideryCheckbox = document.getElementById('embroidery-checkbox');
    const formData = JSON.parse(serializeForm(this.form));
    const originalSKU = formData.id;

    const submitter = evt.submitter;

    if (embroideryCheckbox && embroideryCheckbox.checked) {
      this.handleAddToCartWithEmbroidery(formData, originalSKU, submitter);
    } else {
      this.handleAddToCart(formData, submitter);
    }
  }

  clearErrorMessage() {
    const formError = this.querySelector('[data-product-form-error]');
    if (formError) {
      formError.textContent = '';
      formError.hidden = true;
    }
  }

  handleErrorMessage(errorMessage) {
    const message =
      errorMessage ||
      (window.cartStrings && window.cartStrings.error) ||
      'Unable to add to cart';

    let formError = this.querySelector('[data-product-form-error]');
    if (!formError) {
      formError = document.createElement('div');
      formError.className = 'form__message';
      formError.setAttribute('data-product-form-error', '');
      formError.setAttribute('role', 'alert');

      const buttons = this.querySelector('.product-form__buttons');
      if (buttons) {
        buttons.insertAdjacentElement('afterend', formError);
      } else if (this.form) {
        this.form.appendChild(formError);
      } else {
        this.appendChild(formError);
      }
    }

    formError.hidden = false;
    formError.textContent = message;
  }

  parseAddToCartResponse(response) {
    return response
      .json()
      .catch(() => null)
      .then((parsedState) => {
        const errorMessage = theme.getCartAddError(response, parsedState);
        if (errorMessage) {
          this.handleErrorMessage(errorMessage);
          return null;
        }
        return parsedState;
      });
  }

  restoreSubmitButton(submitButton) {
    submitButton.classList.remove('loading');
    submitButton.removeAttribute('disabled');
  }

  handleAddToCartWithEmbroidery(formData, originalSKU, submitter) {
    const submitButton = submitter || this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    this.clearErrorMessage();

    const embroideryID = Date.now().toString(36);

    const embroideryText = document.getElementById('embroidery-text');
    const embroideryFont = document.querySelector('[name="embroidery-font"]:checked');
    const embroideryColor = document.querySelector('[name="embroidery-color"]:checked');

    let props = {};
    const propertyInputs = this.form.querySelectorAll('.product-input__property');
    propertyInputs.forEach((input) => {
      const inputName = input.getAttribute('data-name');
      props[inputName] = input.value;
    });
    props['Product SKU'] = originalSKU;
    props['_embroidery_id'] = embroideryID;
    props['_LPROP'] = 'FINAL SALE';
    props['Embroidery Text'] = embroideryText.value;
    props['Embroidery Font'] = embroideryFont.value;
    props['Embroidery Color'] = embroideryColor.value;
    props['Item is'] = 'Final Sale';

    const body = JSON.stringify({
      items: [
        {
          ...formData,
          properties: props
        },
        {
          id: '42080058998853',
          quantity: '1',
          properties: {
            '_embroidery_id': embroideryID,
            '_LPROP': 'FINAL SALE',
            'Product SKU': originalSKU
          }
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => this.parseAddToCartResponse(response))
      .then((parsedState) => {
        if (!parsedState) return;
        this.clearErrorMessage();
        theme.addToCartOk();
      })
      .catch((e) => {
        console.error(e);
        this.handleErrorMessage(
          (e && e.message) ||
            (window.cartStrings && window.cartStrings.error)
        );
      })
      .finally(() => {
        this.restoreSubmitButton(submitButton);
      });
  }

  handleAddToCart(formData, submitter) {
    const submitButton = submitter || this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    this.clearErrorMessage();
    
    let props = {};
    
    const propertyInputs = this.form.querySelectorAll('.product-input__property');
    propertyInputs.forEach((input) => {
      const inputName = input.getAttribute('data-name');
      const inputValue = input.value;
      if(inputName != "_narvar"){
        props[inputName] = input.value;
      }
    });

    const body = JSON.stringify({
      ...formData,
      properties: props,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    console.log('body - single item', body);
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => this.parseAddToCartResponse(response))
      .then((parsedState) => {
        if (!parsedState) return;
        console.log('Original item added to cart', parsedState);
        this.clearErrorMessage();
        theme.addToCartOk();
      })
      .catch((e) => {
        console.error(e);
        this.handleErrorMessage(
          (e && e.message) ||
            (window.cartStrings && window.cartStrings.error)
        );
      })
      .finally(() => {
        console.log('RELOAD')
        this.restoreSubmitButton(submitButton);
      });
  }

  renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-count]',
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('product-form', ProductForm);
